import React from "react";
import { Link } from "react-router-dom";
import { Button, Container, Row, Col } from "react-bootstrap";

import activitiesService from "presentation/services/activities";
import activitiesQuestionsService from "presentation/services/activity-questions";
import activitiesAnswersService from "presentation/services/activity-answers";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

import ManualFillForm from 'presentation/pages/activities/elements/manual-fill-form';

class ActivityManualFill extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      form: {},
      actionLoading: false,
      error: false,
      message: '',
      activity: [],
      questions: [],
      answers: [],
      students: [],
      corrections: [],
    };

    this.loadData = this.loadData.bind(this);

  }

  async componentDidMount() {
    const { id, classroomId } = this.props.match.params;


    if (id) {
      await this.loadData(id);
    } else {
      this.setState({ error: true, loading: false, message: "Não foi possível identificar a atividade" });
    }

  }

  mountAnswers = (rawAnswers) => {
    let answers = [];

    for (let i = 0; i < rawAnswers.length; i++) {
      let element = rawAnswers[i];
      let questionId = element.questionId;
      let studentId = element.studentId;
      let answerItem = answers.filter(x => x.questionId == questionId && x.studentId == studentId)[0] || undefined;
      let questionOptionId = parseInt(element.questionOptionId);
      let observations = element.observations || "";

      if (answerItem) {

        if (answerItem.questionOptionId.length < 1) {
          answerItem.questionOptionId = [];
        }

        if (!answerItem.questionOptionId.includes(questionOptionId)) {
          answerItem.questionOptionId.push(questionOptionId);
        }

        answerItem.observations = observations;
      } else {
        answerItem = { studentId: studentId, questionId: questionId, questionOptionId: [questionOptionId], observations: observations };
      }

      var currentAnswers = answers.filter(x => !(x.questionId == answerItem.questionId && x.studentId == answerItem.studentId));

      answers = [...currentAnswers, answerItem];

    }

    return answers;
  }


  loadData = async (rawId) => {

    var activityId = parseInt(rawId);
    var actityResult = await activitiesService.findById(activityId);
    var activityQuestionResults = await activitiesQuestionsService.search({ activityId: [activityId] });
    var studentsResults = await activitiesService.activityStudents(activityId);
    var activityAnswerResults = await activitiesAnswersService.search({ activityId: [activityId] });

    await Promise.all([actityResult, activityQuestionResults, studentsResults, activityAnswerResults]);


    var answers = this.mountAnswers(activityAnswerResults);

    let error = false;
    let message = '';

    this.setState({ activity: actityResult, questions: activityQuestionResults, students: studentsResults, answers: answers, rawAnswers: activityAnswerResults, loading: false, error: error, message: message });
  }

  render() {
    let { loading, error, message, actionLoading, activity } = this.state;
    return (
      <div>
        {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
        {loading === false && error === true && (
          <>
            <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />
            <Container>
              <Row>
                <Col>
                  <Button size="sm" as={Link} to={`/atividades`} variant="secondary" className="float-start m-r-1 mt-4">Voltar</Button>
                </Col>
              </Row>
            </Container>
          </>
        )}
        {loading === false && error == false && (
          <ManualFillForm
            component={this}
            returnTo={`/atividades`}
          />
        )
        }
      </div>
    );
  };
}

export default ActivityManualFill;
